import React from 'react'
import ProfileItemForm from "./ProfileItemForm";
import { Checkbox } from "antd";
import SearchBrandsInput from "../../../components/form/SearchBrandsInput";
import { FormInputComponent } from "../../../components/form/Form";

export default class BrandForm extends ProfileItemForm {

    static ItemType = 'Brand'

    static FormClass = 'talent-role-form talent-interest-form add-talent-form '

    static TypeConfig = {
        icon: 'fas fa-handshake',
        color: '#aaacad'
    }

    canEdit() {
        return false;
    }

    getModelFromProps() {
        if (!TB.keys(TB.tryObject(this.props.model || {})).length) return {};
        return { brand: (this.props.model || {}) };
    }

    /**
     * Handles form change
     *
     * @returns void
     */
    onChange(model) {
        let selectedId = model.brand?.brandId || model.brand?.brandId;

        let brandsIds = TB.map((this.props.user.brands || []), 'id');

        model.is_custom = !!model.is_custom;
        if (model.is_custom) {
            model.brand = undefined;
        }

        if (this.getModelFromProps().brand?.id) {
            brandsIds = TB.filter(brandsIds, id => id !== this.getModelFromProps()?.brand?.id);
        }
        if (selectedId && brandsIds.length && brandsIds.includes(selectedId)) {
            this.formRef.current.forceValidate();
        }

        console.log('onChange', model)

        return this.setState({ model })
    }

    /**
     * Handles form submit button clicks when form is valid
     *
     * @returns void
     */
    onSubmit() {
        let model = {
            ...this.state.model,
            ...this.getModelFromProps()?.brand,
            ...this.state.model?.brand
        };

        if (!model?.id || !model.display_index) {
            let lastBrand = TB.first(
                TB.orderBy(
                    TB.filter(this.props.user.brands || [], brand => TB.isDefined(brand.display_index)), 'display_index',
                    'desc'
                ));
            if (!!lastBrand?.display_index) {
                model.display_index = lastBrand.display_index + 1;
            } else model.display_index = 1;
        }

        console.log(model, 'MODEL ON SUBMIT')
        return super.onSubmit(model);
    }
    /**
     * The fields mapping for the form
     */
    formFields = () => {

        const fields = [
            {
                style: {...styles.fieldSection, alignItems: 'flex-end'},
                fields: {
                    brand: {
                        className: 'search-brand-input [&>.form-group]:mb-0',
                        style: styles.field,
                        component: (
                            <FormInputComponent
                                type="antd-input"
                                fieldName="brand"
                                label={false}
                                required={!this.state.model.is_custom}
                                value={this.state.model.brand}
                            >
                                <SearchBrandsInput isDisabled={this.state.model?.is_custom} />
                            </FormInputComponent>
                        )
                    },
                    is_custom: {
                        component: (
                            <FormInputComponent
                                type="antd-input"
                                fieldName="is_custom"
                                label="Don’t see your brand listed?"
                                labelClassName="pt-0 mb-0.5"
                                value={this.state.model?.is_custom}
                            >
                                <Checkbox checked={this.state.model?.is_custom}>
                                    Add Custom Brand
                                </Checkbox>
                            </FormInputComponent>
                        )
                    }
                }
            },
        ];

        if (this.state.model?.is_custom) {
            fields.push({
                fields: {
                    name: {
                        type: 'text',
                        required: true,
                    },
                    domain: {
                        label: 'Domain (Include https://)',
                        type: 'url',
                        required: true,
                    },
                    icon: {
                        label: 'Logo',
                        type: 'file',
                        required: true,
                    }
                },
            })
        }

        return fields;
    };



}

const styles = {
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: '0 15px',
    },
};